module.exports = __webpack_public_path__ + "static/media/meta-image.9c1650ac.jpg";